import {
    GET_GPS_REQUEST,
    GET_GPS_SUCCESS,
    GET_GPS_FAILURE,
    GET_GPS_STATUSES_REQUEST,
    GET_GPS_STATUSES_SUCCESS,
    GET_GPS_STATUSES_FAILURE,
    SET_STATE_GPS,
    SET_GPS_SELECTED,
    SUBMIT_GPS_REQUEST,
    SUBMIT_GPS_SUCCESS,
    SUBMIT_GPS_FAILURE,
    SUBMIT_GPS_STATUSES_REQUEST,
    SUBMIT_GPS_STATUSES_SUCCESS,
    SUBMIT_GPS_STATUSES_FAILURE,
    SUBMIT_GPS_BATCH_REQUEST,
    SUBMIT_GPS_BATCH_SUCCESS,
    SUBMIT_GPS_BATCH_FAILURE,
    SUBMIT_GPS_DEVICES_VALIDATE_BATCH_REQUEST,
    SUBMIT_GPS_DEVICES_VALIDATE_BATCH_SUCCESS,
    SUBMIT_GPS_DEVICES_VALIDATE_BATCH_FAILURE,
    UNLOCK_GPS_REQUEST,
    UNLOCK_GPS_SUCCESS,
    UNLOCK_GPS_FAILURE,
    CLEAR_VALIDATED_GPS_DEVICES,
    GET_EXPORT_GPS_REQUEST,
    GET_EXPORT_GPS_SUCCESS,
    GET_EXPORT_GPS_FAILURE,
    UNSUBSCRIBE_REQUEST,
    UNSUBSCRIBE_SUCCESS,
    UNSUBSCRIBE_FAILURE,
    CLEAN_UNSUBSCRIBE,
    GET_GPS_SUBSTATUS_REQUEST,
    GET_GPS_SUBSTATUS_SUCCESS,
    GET_GPS_SUBSTATUS_FAILURE,
    GET_HISTORY_GPS_REQUEST,
    GET_HISTORY_GPS_SUCCESS,
    GET_HISTORY_GPS_FAILURE,
    UPDATE_GPS_DEVICE_REQUEST,
    UPDATE_GPS_DEVICE_SUCCESS,
    UPDATE_GPS_DEVICE_FAILURE,
} from "../actions/gps";

import { buildGps_devices } from "../helpers/gps";

const initialState = {
    fetching: false,
    gps_devices: [],
    gps_device: {},
    total: 0,
    statuses: [],
    statusesFetching: false,
    substatus: [],
    substatusFetching: false,
    history: [],
    historyFetching: false,
    submitFetching: false,
    submitSuccess: false,
    submitStatusesFetching: false,
    submitStatusesSucces: false,
    submitValidateBatchFetching: false,
    submitValidateBatchSuccess: false,
    gpsBatchValidations: {},
    unlockFetching: false,
    unlockSucces: false,
    exportableFileName: null,
    fetchingExport: false,
    unsubscribeFetching: false,
    unsubscribeSuccess: false,
    errors: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case UNLOCK_GPS_REQUEST: {
            return {
                ...state,
                unlockFetching: true
            }
        }
        case UNLOCK_GPS_FAILURE: {
            return {
                ...state,
                unlockFetching: false
            }
        }
        case UNLOCK_GPS_SUCCESS: {
            return {
                ...state,
                unlockFetching: false,
                unlockSucces: true,
                submitSuccess: true
            }
        }

        case GET_GPS_REQUEST: {
            return {
                ...state,
                fetching: true,
                unsubscribeFetching: false,
                unsubscribeSuccess: false
            };
        }
        case GET_GPS_SUCCESS: {
            const isLoadingMoreItems = action.payload.page && action.payload.page > 1;
            

            const updatedGpsDevices = isLoadingMoreItems
                ? [...state.gps_devices, ...buildGps_devices(action.payload.gps_devices)]
                : buildGps_devices(action.payload.gps_devices);
            
            return {
                ...state,
                fetching: false,
                gps_devices: updatedGpsDevices,
                total: action.payload.total === 0 ? state.total : action.payload.total
            };
        }
        case GET_GPS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case GET_GPS_STATUSES_REQUEST: {
            return {
                ...state,
                statuses: [],
                statusesFetching: true
            };
        }
        case GET_GPS_SUBSTATUS_REQUEST: {
            return {
                ...state,
                substatuses: [],
                substatusFetching: true
            };
        }
        case GET_GPS_SUBSTATUS_SUCCESS: {
            return {
                ...state,
                substatus: action.payload.substatus,
                substatusFetching: false
            };
        }
        case GET_GPS_SUBSTATUS_FAILURE: {
            return {
                ...state,
                substatusFetching: false
            };
        }
        case GET_GPS_STATUSES_SUCCESS: {
            return {
                ...state,
                statuses: action.payload.statuses,
                statusesFetching: false
            };
        }
        case GET_GPS_STATUSES_FAILURE: {
            return {
                ...state,
                statusesFetching: false
            };
        }
        case GET_GPS_SUBSTATUS_REQUEST: {
            return {
                ...state,
                substatus: [],
                substatusFetching: true
            };
        }
        case GET_GPS_SUBSTATUS_SUCCESS: {
            return {
                ...state,
                substatus: action.payload.substatus,
                substatusFetching: false
            };
        }
        case GET_GPS_SUBSTATUS_FAILURE: {
            return {
                ...state,
                substatusFetching: false
            };
        }
        case GET_HISTORY_GPS_REQUEST: {
            return {
                ...state,
                history: [],
                historyFetching: true
            };
        }
        case GET_HISTORY_GPS_SUCCESS: {
            const historyData = Array.isArray(action.payload.history) ? action.payload.history : [];
            return {
                ...state,
                history: historyData,
                historyFetching: false
            };
        }
        case GET_HISTORY_GPS_FAILURE: {
            return {
                ...state,
                historyFetching: false
            };
        }
        case SUBMIT_GPS_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_GPS_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true
            };
        }
        case SUBMIT_GPS_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case UPDATE_GPS_DEVICE_REQUEST:
    return {
        ...state,
        updating: true,
        error: null
    };
case UPDATE_GPS_DEVICE_SUCCESS:
    return {
        ...state,
        updating: false,
        gps_devices: state.gps_devices.map(device => 
            device._id === action.payload.gpsDevice._id 
                ? action.payload.gpsDevice 
                : device
        )
    };
case UPDATE_GPS_DEVICE_FAILURE:
    return {
        ...state,
        updating: false,
        error: action.error
    };
        case SUBMIT_GPS_STATUSES_REQUEST: {
            return {
                ...state,
                submitStatusesFetching: true,
                submitStatusesSucces: false
            };
        }
        case SUBMIT_GPS_STATUSES_SUCCESS: {
            return {
                ...state,
                submitStatusesFetching: false,
                submitStatusesSucces: true
            };
        }
        case SUBMIT_GPS_STATUSES_FAILURE: {
            return {
                ...state,
                submitStatusesFetching: false,
                submitStatusesSucces: false
            };
        }
        case SUBMIT_GPS_DEVICES_VALIDATE_BATCH_REQUEST: {
            return {
                ...state,
                submitValidateBatchFetching: true,
                submitValidateBatchSuccess: false
            };
        }
        case SUBMIT_GPS_DEVICES_VALIDATE_BATCH_SUCCESS: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: true,
                gpsBatchValidations: action.payload.validations
            };
        }
        case SUBMIT_GPS_DEVICES_VALIDATE_BATCH_FAILURE: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: false
            };
        }
        case SET_STATE_GPS: {
            return {
                ...state,
                ...action.payload
            };
        }
        case SET_GPS_SELECTED: {
            return {
                ...state,
                gps_device: action.payload.gps_device
            };
        }
        case SUBMIT_GPS_BATCH_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_GPS_BATCH_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true
            };
        }
        case SUBMIT_GPS_BATCH_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case CLEAR_VALIDATED_GPS_DEVICES: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: false,
                gpsBatchValidations: {}
            };
        }
        case GET_EXPORT_GPS_REQUEST: {
            return {
                ...state,
                fetchingExport: true
            }
        }
        case GET_EXPORT_GPS_SUCCESS: {
            return {
                ...state,
                exportableFileName: action.payload.fileName,
                fetchingExport: false
            }
        }
        case GET_EXPORT_GPS_FAILURE: {
            return {
                ...state,
                fetchingExport: false
            }
        }
        case UNSUBSCRIBE_REQUEST: {
            return {
                ...state,
                unsubscribeFetching: true,
                unsubscribeSuccess: false,
            }
        }
        case UNSUBSCRIBE_FAILURE: {
            return {
                ...state,
                unsubscribeFetching: false,
                unsubscribeSuccess: false
            }
        }
        case UNSUBSCRIBE_SUCCESS: {
            return {
                ...state,
                unsubscribeFetching: false,
                unsubscribeSuccess: true,
                errors: action.payload.errors
            }
        }
        case CLEAN_UNSUBSCRIBE: {
            return { 
                ...state,
                unsubscribeFetching: false,
                unsubscribeSuccess: false,
                errors: []
            }
        }
        default:
            return state;
    }
};
